import { createContext } from 'react';
import type { ThemeContextValue } from './theme';

/* Kept out of theme.tsx so its identity survives a hot reload of that file.
   See src/core/i18nContext.ts for what goes wrong otherwise. */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
